import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import CheckIcon from '@mui/icons-material/Check';

import Config from "../../../../../config";
import {getCommonCoords, getFeatureCoords, getLayerCenter, navFeatureCLick} from "../../lookFunctions";
import {addToCart, setCanvasScale, updateCanvasCount} from "../../../../../actions/actionFunctions";
import LookCanvasContext from "../../../lookCanvasContext";
import {getCurrentLayout} from "../../../../appLayout";
import {LOOK_WALLS_ONLY} from "../../../core/constants";
import {enableRelatedFeature} from "../../lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import WithClickCount from "../../../hocs/withClickCount";
import {setWizardSelectedValues} from "../../../../../actions/wizardFunctions";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {featureGroupInterface} from "../../../../../interfaces/featureInterface";
import {findFeatureBySelectedFilters, getFilterValueThumbnailAndStyles} from "./lookWizardFunctions";
import {filterGroupInterface, filterValueInterface} from "../../../../../interfaces/filterInterface";

const LookWizardSectionFilterItem = (props) => {

  const {filterValue, filterGroup, wizardGroup, featureGroup, lookViewType, updateCanvasCount, isMobile, addToCart,
    qtActiveCategory, setCanvasScale, wizardSelectedValues, wizardActiveStep, setWizardSelectedValues} = props;

  // const [canRender, setCanRender] = useState(false);
  const listFilterClick = (imageCanvas, maxClickCountReached) => {
    if (Config.isDevMode()) {
      console.log("filterValue", filterValue);
    }
    const analyticsLabel = LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardListFilter + Analytics.getStringForAnalytics(filterValue.displayText);
    Analytics.sendClickEvent(analyticsLabel);

    let zoomFeature = findFeatureBySelectedFilters(featureGroup, [{
      filterId: filterValue.id,
      filterGroupId: filterGroup.id,
    }]);
    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    setWizardSelectedValues({
      [wizardActiveStep]: {
        wizardGroup,
        selectedFilter: filterValue
      }
    });

    const layout = getCurrentLayout();
    if (zoomFeature) {
      navFeatureCLick(zoomFeature);
      enableRelatedFeature(zoomFeature, addToCart, qtActiveCategory);
      // const parent = zoomFeature.getParent();
      // if (parent.disabled) {
      //   parent.disabled = false;
      //   parent.disabledClick();
      // }
      updateCanvasCount();
      if (imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom && !LOOK_WALLS_ONLY.includes(zoomFeature.partId)) {
        const commonCoords = getFeatureCoords(zoomFeature, true) || getCommonCoords(featureGroup || zoomFeature.getParent(), zoomFeature, imageCanvas.current.canvas);
        const center = getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile);
        if (center) {
          imageCanvas.current.pinchZoom.zoomToCenter(center, 0, false, layout.partIdExistInQtCategory(zoomFeature.partId));
          setCanvasScale(imageCanvas.current.pinchZoom.options.tapZoomFactor)
        }
      }
    }
  }

  const {styles} = getFilterValueThumbnailAndStyles(filterValue, filterGroup);

  const isActive = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFilter
    && (wizardSelectedValues[wizardActiveStep].selectedFilter.id === filterValue.id);

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithClickCount>
          {(maxClickCountReached) => (
            <li className={"lm-feature lm-feature--type-" + lookViewType + (isActive ? " lm-feature--active" : "")}
                onClick={() => listFilterClick(imageCanvas, maxClickCountReached)}>
              <div className="lm-feature__thumbnail">
                {isActive ? (
                  <div className="lm-feature__checkmark">
                    <CheckIcon fontSize="small"/>
                  </div>
                ) : null}
                <div className="feature-thumbnail" style={styles}/>
              </div>
              <div className="lm-feature__content lm-feature__content--no-price">
                <span className="lm-feature__content-name">
                  {filterValue.displayText}
                </span>
              </div>
            </li>
          )}
        </WithClickCount>
      )}
    </LookCanvasContext.Consumer>
  )
};

LookWizardSectionFilterItem.propTypes = {
  filterValue: PropTypes.shape(filterValueInterface),
  filterGroup: PropTypes.shape(filterGroupInterface),
  featureGroup: PropTypes.shape(featureGroupInterface),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {isMobile} = store.serverState;
  const {activePreset, bvPresets, canvasScale} = store.bathroomVisualizerState;
  const {qtActiveCategory} = store.qtState;
  const {wizardSelectedValues, wizardActiveStep} = store.wizardState;

  return {
    lookViewType,
    isMobile,
    activePreset,
    bvPresets,
    qtActiveCategory,
    canvasScale,
    wizardSelectedValues,
    wizardActiveStep,
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
  addToCart,
  setCanvasScale,
  setWizardSelectedValues,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionFilterItem)
)
